<template>
  <basic-container>
    <div class="dialog-root">
      <div class="container">
        <avue-form ref="formRef" :option="formOption" v-model="formData"> </avue-form>
      </div>
      <!-- 按钮占位区域 -->
      <div class="placeholder"></div>
      <!-- 底部操作按钮 -->
      <div class="btn">
        <el-button type="primary" @click="doSave" :loading="btnLoading" >确认</el-button>
        <el-button @click="doClose" >取消</el-button>
      </div>
    </div>

    <el-dialog title="提示" width="40%"
               :visible.sync="tipShow"
               :append-to-body="true"
               :modal-append-to-body="true"
               :close-on-click-modal="false"
               :destroy-on-close="true">
      <div class="plate-change-tip">
        <div class="t1">
          <span >红冲失败！失败原因：{{failMsg}}</span>
          <br/>
          <span >请解决问题后，重新红冲！</span>
        </div>
      </div>
      <template #footer>
        <div>
          <el-button @click="closeTipShow">确 定</el-button>
        </div>
      </template>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  invoiceRed,
} from "@/api/v4ward/digitaltickets/taxinvoicerecord/TaxInvoiceRecord.js";
import {mapGetters} from "vuex";
import { getInvoiceTypeList } from '@/api/v4ward/digitaltickets/invoiceType';
import { getDictionary } from '@/api/common.js';

export default {
  components: {

  },
  props: {
    rowData:{},
  },
  data() {
    return {
      failMsg: '',
      tipShow: false,
      btnLoading: false,
      formOption: {
        labelWidth: 100,
        menuBtn: false,
        column: [
          {
            label: '蓝票主键id',
            prop: 'blueId',
            display: false
          },
          {
            label: '红冲蓝票号',
            prop: 'invoiceNo',
            disabled: true,
            span: 24,
            rules: [{
              required: true,
              message: "请输入红冲蓝票号",
              trigger: "change"
            }]
          },
          {
            label: '销售方信息',
            prop: 'sellerName',
            disabled: true,
            span: 24,
            rules: [{
              required: true,
              message: "请输入销售方信息",
              trigger: "change"
            }]
          },
          {
            label: '票据类型',
            type: 'select',
            prop: 'invoiceType',
            dicData:[],
            props: {
              label: 'name',
              value: 'code',
            },
            disabled: true,
            span: 24,
            rules: [{
              required: true,
              message: "请选择票据类型",
              trigger: "change"
            }]
          },
          {
            label: '红冲原因',
            prop: 'redReason',
            type: 'select',
            dicData:[],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            span: 24,
            rules: [{
              required: true,
              message: "请选择红冲原因",
              trigger: "change"
            }]
          },
        ],
      },
      formData:{

      },
    };
  },
  watch: {
  },
  mounted(){
    // this.adjustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  created(){
    this.initData();
    this.formData = this.rowData;
    this.formData.blueId = this.rowData.id;
    this.formData.redReason = '01';
    console.log("this.formData", this.formData);
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        delBtn: this.vaildData(this.permission.feeitemtax_delete, false),
        editBtn: this.vaildData(this.permission.feeitemtax_edit, false),
      };
    },
  },
  methods: {
    closeTipShow(){
      this.tipShow = false;
      this.doClose();
    },
    initData(){
      //获取票据类型
      getInvoiceTypeList().then(({data})=>{
        this.findObject(this.formOption.column, 'invoiceType').dicData = data;
      });
      //获取红冲原因
      getDictionary('invoice_red_reason').then((res) => {
        this.findObject(this.formOption.column, 'redReason').dicData = res.data;
      });
    },
    doSave(){
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          invoiceRed(this.formData, {
            showLoading: { text: '处理中...' },
          }).then((res) => {
            console.log("红冲结果", res);
            let data = res.data;
            if(data.success){
              this.doClose();
            }else{
              console.log('显示提示语')
              this.failMsg = data.failMsg;
              this.tipShow = true;
            }
          });
        }
      });
    },
    doClose() {
      this.rowData = {};
      this.formData = {};
      this.$emit('close');
    },
    // adjustView() {
    //   // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
    //   setTimeout(() => {
    //     window.onresize = () => {
    //       this.$nextTick(() => {
    //         this.$refs.crud.refreshTable();
    //       });
    //     };
    //   });
    // },
  }
};
</script>

<!--最大化-->
<style lang="scss" scoped>
::v-deep .el-form-item {
  width: 100%;
}
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}
</style>
